import React from 'react'
import GameSummaryNavigation from './GameSummaryNavigation'
import GameSummary from './GameSummary'
import Banner from './Banner'

const GameSummaryHome = () => {
	return (
		<div>
			<GameSummaryNavigation />
			<Banner />
			<GameSummary />
		</div>
	)
}

export default GameSummaryHome
